/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Feat_4_DescInputs */

const en_b2b_feat_4_desc = /** @type {(inputs: B2b_Feat_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export orders and high-intent AI concierge leads instantly via CSV to import into Salesforce, HubSpot, or GoHighLevel.`)
};

const es_b2b_feat_4_desc = /** @type {(inputs: B2b_Feat_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporta pedidos y leads instantáneamente vía CSV para importarlos en Salesforce o HubSpot.`)
};

const fr_b2b_feat_4_desc = /** @type {(inputs: B2b_Feat_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportez instantanément les commandes et les prospects à forte intention via CSV pour les importer dans Salesforce, HubSpot ou GoHighLevel.`)
};

const de_b2b_feat_4_desc = /** @type {(inputs: B2b_Feat_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportiere Bestellungen und Leads sofort via CSV.`)
};

const id_b2b_feat_4_desc = /** @type {(inputs: B2b_Feat_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekspor pesanan dan prospek pramutamu AI berniat tinggi secara instan melalui CSV untuk diimpor ke Salesforce, HubSpot, atau GoHighLevel.`)
};

/** @type {(inputs: B2b_Feat_4_DescInputs) => LocalizedString} */
const ja_b2b_feat_4_desc = en_b2b_feat_4_desc;

/** @type {(inputs: B2b_Feat_4_DescInputs) => LocalizedString} */
const zh_b2b_feat_4_desc = en_b2b_feat_4_desc;

/** @type {(inputs: B2b_Feat_4_DescInputs) => LocalizedString} */
const ar_b2b_feat_4_desc = en_b2b_feat_4_desc;

/** @type {(inputs: B2b_Feat_4_DescInputs) => LocalizedString} */
const it_b2b_feat_4_desc = en_b2b_feat_4_desc;

/** @type {(inputs: B2b_Feat_4_DescInputs) => LocalizedString} */
const ru_b2b_feat_4_desc = en_b2b_feat_4_desc;

/** @type {(inputs: B2b_Feat_4_DescInputs) => LocalizedString} */
const pt_b2b_feat_4_desc = en_b2b_feat_4_desc;

/** @type {(inputs: B2b_Feat_4_DescInputs) => LocalizedString} */
const ko_b2b_feat_4_desc = en_b2b_feat_4_desc;

/**
* | output |
* | --- |
* | "Export orders and high-intent AI concierge leads instantly via CSV to import into Salesforce, HubSpot, or GoHighLevel." |
*
* @param {B2b_Feat_4_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_feat_4_desc = /** @type {((inputs?: B2b_Feat_4_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Feat_4_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_feat_4_desc(inputs)
	if (locale === "es") return es_b2b_feat_4_desc(inputs)
	if (locale === "fr") return fr_b2b_feat_4_desc(inputs)
	if (locale === "de") return de_b2b_feat_4_desc(inputs)
	if (locale === "ja") return ja_b2b_feat_4_desc(inputs)
	if (locale === "zh") return zh_b2b_feat_4_desc(inputs)
	if (locale === "ar") return ar_b2b_feat_4_desc(inputs)
	if (locale === "id") return id_b2b_feat_4_desc(inputs)
	if (locale === "it") return it_b2b_feat_4_desc(inputs)
	if (locale === "ru") return ru_b2b_feat_4_desc(inputs)
	if (locale === "pt") return pt_b2b_feat_4_desc(inputs)
	return ko_b2b_feat_4_desc(inputs)
});